module.exports = __webpack_public_path__ + "img/vaccin.9c5aab4d.svg";